import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function KeyboardTabIcon(props: IconProps) {
    return <Icon {...props} iconKey={"keyboard_tab"}/>
}
